import { TableColumnsType, Tooltip, Button, Typography } from 'antd';
import { EditOutlined } from '@ant-design/icons';
// import { imageUrl } from '@/constants/request.constant';
import { Table } from '@/components/tables/table';
import { css } from '@emotion/react';
import { formatDateToDDMMYYYY } from '@/utils/common';
import { useModal } from '@/hooks/modal.hook';
import { FoodManagementGroupEditModal } from '@/components/modals/food-management/food-management-group-edit.modal';
import {
  getListGroupFood,
  watchListGroupFood,
  watchGroupFoodPagination,
  resetMessages,
  watchFoodMessage
} from '@/redux/slices/food.slice';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { useCallback, useEffect } from 'react';
import { PAGINATION_PARAMS } from '@/constants/pagination.constant';
import { setMessages } from '@/redux/slices/app.slice';

type PageChangeParams = {
  page?: number;
  pageSize?: number;
};

const FoodGroupManagementTable = () => {
  const { openModal, closeModal } = useModal();
  const dispatch = useAppDispatch();
  const pagination = useAppSelector(watchGroupFoodPagination);
  const listGroupFood = useAppSelector(watchListGroupFood);
  const message = useAppSelector(watchFoodMessage);

  useEffect(() => {
    dispatch(getListGroupFood());
  }, [dispatch]);

  const handlePageChange = useCallback(
    ({
      page = PAGINATION_PARAMS.offset,
      pageSize = PAGINATION_PARAMS.limit,
    }: PageChangeParams) => {
      dispatch(getListGroupFood({
        offset: page,
        limit: pageSize
      }));
    },
    [dispatch]
  );

  const handleEdit = (group: any) => {
    openModal(
      <FoodManagementGroupEditModal group={group} onCancel={closeModal} />,
      {
        width: 600
      }
    );
  };

  useEffect(() => {
    if (message) {
      dispatch(
        setMessages([
          {
            type: message.type,
            message: message.message,
            description: message.description
          }
        ])
      );

      dispatch(resetMessages());
    }
  }, [dispatch, message]);

  const columns: TableColumnsType<any> = [
    {
      title: 'STT',
      render: (_, __, index) => index + 1,
      width: 1
    },
    {
      title: 'Tên nhóm thực phẩm',
      dataIndex: 'name',
      key: 'name',
      width: 200
    },
    {
      title: 'Số lượng thực phẩm',
      dataIndex: 'quantityFood',
      key: 'quantityFood',
      width: 200
    },
    {
      title: 'Cập nhật mới nhất',
      dataIndex: 'modifiedDate',
      key: 'modifiedDate',
      width: 200,
      render: (record) => (record ? formatDateToDDMMYYYY(record) : '')
    },
    {
      title: 'Ngày tạo',
      dataIndex: 'createdDate',
      key: 'createdDate',
      width: 200,
      render: (record) => (record ? formatDateToDDMMYYYY(record) : '')
    },
    {
      title: 'Thao tác',
      key: 'action',
      fixed: 'right',
      width: 104,
      render: (record) => (
        <Tooltip title='Cập nhật'>
          <Button
            type='primary'
            icon={<EditOutlined />}
            onClick={() => handleEdit(record)}
            css={editButtonStyles}
          />
        </Tooltip>
      )
    }
  ];

  return (
    <div css={boxStyles}>
      <Typography.Title level={5}>Danh sách nhóm thực phẩm</Typography.Title>

      <Table<any>
        columns={columns}
        dataSource={listGroupFood}
        pagination={{
          showQuickJumper: false,
          showSizeChanger: true,
          current: pagination.curPage,
          pageSize: pagination.limitPage,
          total: pagination.totalRows,
          onChange: (page, pageSize) => {
            handlePageChange({ page, pageSize });
          }
        }}
      />
    </div>
  );
}
export default FoodGroupManagementTable;
const boxStyles = css`
  padding: 1rem;
  background: var(--white-color);
  box-shadow: 0.02rem 0.04rem 0.2rem var(--gray-light-color);
  &:nth-of-type(2) {
    padding: 1.6rem 1rem;
  }

  .ant-table-thead > tr > th {
    background: var(--blue-dark-color) !important;
    color: var(--white-color);
  }

  .ant-table-cell::before {
    display: none;
  }
`;

const editButtonStyles = css`
  background-color: var(--yellow-light-color) !important;
  color: var(--white-color);
`;
